module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zk-badge"
  }, [_vm._t("default"), _vm._v(" "), _c('sup', {
    staticClass: "zk-badge__content",
    class: {
      'is-fixed': _vm.$slots.default, 'is-dot': _vm.isDot
    },
    domProps: {
      "textContent": _vm._s(_vm.content)
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-2ef4f8d1"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/badge/src/badge.vue
// module id = 247
// module chunks = 0